module.exports = __webpack_public_path__ + "media/images/country_flags/by-afae2d34286007698ab79a1e6e545f45.png";